import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses: Record<NonNullable<ContainerProps['size']>, string> = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
};

export const Container = forwardRef<HTMLDivElement, ContainerProps>(function Container(
  { size = 'lg', className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('mx-auto w-full px-4 sm:px-6', sizeClasses[size], className)}
      {...rest}
    />
  );
});
